<template>
    <div class="vx-flex vx-items-center vx-justify-between vx-gap-2 vx-text-ellipsis">
        <vx-badge
            class="vx-cursor-pointer"
            @click.prevent="copyText(props.modelValue.id)"
            size="xs"
            color="slate"
            >{{ props.modelValue.id }}</vx-badge
        >

        <div
            class="vx-font-bold vx-text-slate-700 vx-text-lg vx-line-clamp-none vx-break-all lg:vx-line-clamp-3 vx-cursor-pointer"
            @click.prevent="copyText(props.modelValue.name)"
            :title="props.modelValue.name"
        >
            {{ props.modelValue.name }}
        </div>
    </div>

</template>
<script setup>
import {
    VxBadge,
} from "@voxie/frontend-components";
import { useCopyText } from "~/composables/useCopyText";

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
});

const { copyText } = useCopyText();
</script>
